import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import WindowResizeListener from "react-window-size-listener";
import { InfoCircleOutlined, MenuOutlined, SearchOutlined, ShoppingOutlined } from '@ant-design/icons';
import { t } from '@lingui/macro';
import { Badge, Button, Col, Input, Layout, Menu, Row } from 'antd';
import CheckoutConfirmationModal from "bukku/components/Store/CheckoutConfirmationModal";
import CheckoutDrawer from 'bukku/components/Store/CheckoutDrawer';
import FormatNumber from 'bukku/components/Store/FormatNumber';
import StoreNoticeModal from "bukku/components/Store/NoticeModal";
import StoreProductDrawer from "bukku/components/Store/ProductDrawer";
import StoreInfoDrawer from 'bukku/components/Store/StoreInfoDrawer';
import StoreActions from "bukku/redux/Store/actions";
import PageLoading from "./Loading";
import PendingPayment from "./PendingPayment";
import { BukkuStoreStyled } from './StoreApp.styles';
import StoreNotFound from "./StoreNotFound";
import StoreOffline from "./StoreOffline";
import BukkuTooltip from '../../components/Tooltip';
import {getStoreUrl} from "../../routers/StoreRouter/helpers/getStoreUrl";
import StoreRouter from "../../routers/StoreRouter/router";

const { Header, Content, Sider, Footer } = Layout;

const {
    readStore,
    updateWidth,
    toggleCheckoutDrawer,
    toggleStoreInfoDrawer,
    resetProducts,
    changeCurrent,
} = StoreActions;

class StoreApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: '',
        };
    }

    componentDidMount() {
        const { readStore } = this.props;
        readStore();
        this.setSiderCurrent();
        this.setSiderAndSearchVisibility();
    }

    componentDidUpdate(prevProps) {
        const {
            gridSize, // 'xs', 'sm', 'md', 'lg', 'xl'
            location,
        } = this.props;

        if (prevProps.gridSize !== gridSize)
            this.setSiderAndSearchVisibility();

        if (location.pathname !== prevProps.location.pathname)
            this.setSiderCurrent();
    }

    setSiderAndSearchVisibility = () => {
        const {
            width,
        } = this.props;
        this.setState({
            isSiderCollapsed: width < 992, // Initial collapse status
            isSiderLocked: width >= 992, // Locked for lg & beyond.
            // isCheckoutDrawerOpen: false,
            isSearchOn: width >= 576, // Whether to show search on load.
            isSearchLocked: width >= 576, // Locked for sm & beyond.
        });
    };

    // Set sider's focus key on first load
    setSiderCurrent = () => {
        const { changeCurrent, location, match } = this.props;
        const { pathname } = location; // /store/NAME/category/1
        const { url } = match; //  /store/NAME
        let current = pathname.replace(url, '');
        if (current[0] === '/')
            current = current.substring(1);
        console.log('aaa changeCurrent', current);
        changeCurrent(current || 'home');
    };

    // value is optional, if not specified, collapse or uncollapse based on current state
    onToggleSider = (e, value) => {
        const {
            isSiderCollapsed,
            isSiderLocked,
        } = this.state;

        if (!isSiderLocked) {
            this.setState({
                isSiderCollapsed: value || !isSiderCollapsed,
            });
        }
    };

    renderToggleButton = () => <MenuOutlined onClick={this.onToggleSider} />;

    onMenuItemClick = e => {
        const {
            current,
            changeCurrent,
            resetProducts,
        } = this.props;
        console.log('aaa current onMenuItemClick', {
            current, e,
        });
        if (current !== e.key) {
            changeCurrent(e.key);
            resetProducts();
        }
    };

    renderSider = () => {
        const {
            isSiderCollapsed,
        } = this.state;
        const {
            categories,
            current,
        } = this.props;
        console.log('aaa renderSider current', isSiderCollapsed);
        return (
            <Sider
                className="sider"
                trigger={null}
                collapsible
                collapsed={isSiderCollapsed}
                defaultCollapsed={isSiderCollapsed}
                width={240}
                collapsedWidth={0}
            >
                <Menu
                    onClick={this.onMenuItemClick}
                    selectedKeys={current}
                    // selectedKeys={'category/1'}
                    items={[
                        {
                            key: 'home',
                            label: (
                                <Link to={getStoreUrl('/')} onClick={this.onToggleSider}>
                                    <strong>Home</strong>
                                </Link>
                            ),
                        },
                        ...categories.map(c => (
                            {
                                key: `category/${c.id}`,
                                label: (
                                    <Link
                                        to={getStoreUrl(`/category/${c.id}`)}
                                        onClick={this.onToggleSider}
                                    >
                                        {c.name}
                                    </Link>
                                ),
                            }
                        )),
                    ]}
                />
            </Sider>
        );
    };

    onCheckoutDrawerOpen = () => {
        const { toggleCheckoutDrawer } = this.props;
        toggleCheckoutDrawer(true);
    };

    goHome = e => {
        const {
            history,
            changeCurrent,
        } = this.props;

        this.onToggleSider(e, true); // true to collapse Sider
        changeCurrent('home');
        history.push(getStoreUrl('/'));
    };

    renderLogo = () => {
        const {
            store,
            toggleStoreInfoDrawer,
        } = this.props;
        const {
            isSearchOn,
        } = this.state;

        // Hide?
        if (isSearchOn && window.innerWidth < 576)
            return null;

        if (store.logoUrl) {
            return (
                <Row gutter={6}>
                    <Col>
                        <BukkuTooltip
                            title={store.friendlyName}
                            onClick={this.goHome}
                            // popupContainerId="parentElement"
                            // popupType="parent"
                        >
                            <img src={store.logoUrl} alt="" />
                        </BukkuTooltip>
                    </Col>
                    <Col>
                        <InfoCircleOutlined
                            className="icon__store-info"
                            onClick={() => toggleStoreInfoDrawer(true)}
                        />
                    </Col>
                </Row>
            );
        }
        return (
            <Row gutter={6}>
                <Col>
                    <h1 onClick={this.goHome}>
                        {store.friendlyName}
                    </h1>
                </Col>
                <Col>
                    <InfoCircleOutlined
                        className="icon__store-info"
                        onClick={() => toggleStoreInfoDrawer(true)}
                    />
                </Col>
            </Row>
        );
    };

    toggleSearch = () => {
        const {
            isSearchOn,
            isSearchLocked,
        } = this.state;

        if (!isSearchLocked) {
            this.setState({
                isSearchOn: !isSearchOn,
            });
        }
    };

    onSearch = () => {
        // const { value } = e.target;
        const {
            history,
        } = this.props;
        const {
            searchValue,
        } = this.state;

        if (searchValue !== '') {
            history.push({
                pathname: getStoreUrl(`/search/${searchValue}`),
            });
        }

        this.toggleSearch();
    };

    onSearchChange = e => {
        this.setState({
            searchValue: e.target.value,
        });
    };

    renderSearch = () => {
        const {
            isSearchOn,
        } = this.state;

        if (isSearchOn) {
            return (
                <div className="header-search expanded">
                    <Row>
                        <Col>
                            <Input
                                size="large"
                                bordered={false}
                                placeholder={t`Search Products`}
                                onPressEnter={this.onSearch}
                                onChange={this.onSearchChange}
                                autoFocus
                            />
                        </Col>
                        <Col className="search-col">
                            <SearchOutlined
                                onClick={this.onSearch}
                            />
                        </Col>
                    </Row>
                </div>
            );
        }
        return (
            <div className="header-search">
                <SearchOutlined onClick={this.toggleSearch} />
            </div>
        );
    };

    renderMenuMask = () => {
        const {
            isSiderCollapsed,
        } = this.state;

        if (!isSiderCollapsed)
            return <div className="sider-mask" onClick={this.onToggleSider} />;
        return null;
    };

    renderPoweredBy = () => (
        <div className="powered">
            <h3>
                Powered by
                <BukkuTooltip
                    title={t`Bukku Store`}
                    // popupContainerId="parentElement"
                    // popupType="parent"
                >
                    <img src="/img/store/store-logo.png" alt="" />
                </BukkuTooltip>
            </h3>
            <h4>
                A commission-free online ordering system,
                &nbsp;
                <a href="https://bukku.my" target="_blank" rel="noopener noreferrer">
                    claim your store for free!
                </a>
            </h4>
        </div>
    );

    renderContent = () => {
        const { storeOffline } = this.props;

        if (storeOffline)
            return <StoreOffline />;

        return (
            <>
                <StoreRouter />
                {this.renderPoweredBy()}
                <CheckoutDrawer />
                <StoreProductDrawer />
                <StoreNoticeModal />
                <StoreInfoDrawer />
                <PendingPayment />
                <CheckoutConfirmationModal />
            </>
        );
    };

    render() {
        const {
            sessionReady,
            storeNotFound,
            totals,
            store,
            shoppingCart,
            updateWidth,
        } = this.props;

        if (!sessionReady)
            return <PageLoading />;

        if (storeNotFound)
            return <StoreNotFound />;

        const shoppingCartCount = shoppingCart.reduce((acc, item) => acc + item.qty, 0);
        return (
            <BukkuStoreStyled>
                <WindowResizeListener onResize={windowSize => updateWidth(windowSize.windowWidth)} />
                <Layout className="main-layout">
                    <Header className="header">
                        <div className="header-left">
                            <Row>
                                <Col className="toggle-col">
                                    {this.renderToggleButton()}
                                </Col>
                                <Col className="logo-col">
                                    {this.renderLogo()}
                                </Col>
                            </Row>
                        </div>
                        {this.renderSearch()}
                    </Header>

                    <Layout className="inner-layout">
                        {this.renderMenuMask()}
                        {this.renderSider()}
                        <Content className="content">
                            {this.renderContent()}
                        </Content>
                    </Layout>
                    <Footer
                        // className='footer'
                        className={`footer__checkout ${!shoppingCartCount && 'display-none'}`}
                    >
                        <Row align="middle" gutter={16}>
                            <Col flex="none">
                                <Badge
                                    size="small"
                                    count={shoppingCartCount}
                                >
                                    <ShoppingOutlined style={{ fontSize: 'x-large', color: 'white' }} />
                                </Badge>
                            </Col>
                            <Col flex="none">
                                <FormatNumber
                                    currency={store.currencySymbol}
                                    amount={totals.grandTotal}
                                    fontSizeLevel="large"
                                />
                            </Col>
                            <Col xs={0} sm={8} lg={12} xxl={16} />
                            <Col flex="auto">
                                <Button
                                    style={{ width: '100%', height: '100%' }}
                                    onClick={this.onCheckoutDrawerOpen}
                                >
                                    View Cart
                                </Button>
                            </Col>
                        </Row>
                    </Footer>
                </Layout>
            </BukkuStoreStyled>
        );
    }
}

export default connect(state => ({
    storeNotFound: state.Store.storeNotFound,
    storeOffline: state.Store.storeOffline,
    pendingPayment: state.Store.pendingPayment,
    sessionReady: state.Store.sessionReady,
    store: state.Store.store,
    storeInfoDrawerVisible: state.Store.storeInfoDrawerVisible,
    categories: state.Store.categories,
    totals: state.Store.totals,
    shoppingCart: state.Store.shoppingCart,
    current: state.Store.current,
    gridSize: state.Store.gridSize,
    width: state.Store.width,
}), {
    readStore,
    updateWidth,
    toggleCheckoutDrawer,
    toggleStoreInfoDrawer,
    resetProducts,
    changeCurrent,
})(StoreApp);
